import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import ListNewTest from "../../components/TestCatalogComponents/NewTest/ListNewTest";
import {getNewTests} from '../../Api/tests';

function NewTest() {
  const [tests, setTests] = useState([])

  useEffect(() => {
    getNewTests(setTests);
  }, []);
  return (
    <div className="w-full h-full">
      <Header Section="TestCatalog" />
      <div className="w-full h-full flex flex-col px-5 lg:px-20 mt-10  mb-20">
        <div className="w-full flex space-x-5 border-b-2 pb-2">
          <Link to="/" className="font-Lato-Regular text-xl text-[#B7C933]">
            Home
          </Link>
          <p className="font-Lato-Regular text-xl text-[#B7C933]">|</p>
          <Link
            to="/TestCatalog"
            className="font-Lato-Regular text-xl text-[#B7C933]"
          >
            Test Catalog
          </Link>
          <p className="font-Lato-Regular text-xl pl-5">New Test</p>
        </div>
        <div className="w-full mt-10">
          <h1 className="text-2xl font-Lato-Bold">New Test</h1>
          <p className="font-Lato-Regular text-lg mt-4">
            New test published in the previous 90 days are listed in the
            following table.
          </p>
        </div>
        <ListNewTest Data={tests} />
      </div>
      <Footer />
    </div>
  );
}

export default NewTest;
